var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: {
      title: _vm.$t("adjustBalance"),
      rightMethod: _vm.onSubmitted,
      medium: ""
    },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            !_vm.isTenant
              ? _c(
                  "v-layout",
                  { attrs: { "justify-space-between": "" } },
                  [
                    _c(
                      "v-flex",
                      [
                        _c(
                          "v-layout",
                          {
                            attrs: {
                              row: "",
                              wrap: "",
                              "justify-space-between": ""
                            }
                          },
                          [
                            _c(
                              "v-flex",
                              { attrs: { md3: "" } },
                              [
                                _c("v-text-field", {
                                  staticClass: "required_field",
                                  attrs: {
                                    label: _vm.$t("amount"),
                                    prefix: "$",
                                    hint: _vm.$t("billingChangeHint"),
                                    "persistent-hint": "",
                                    rules: [_vm.fieldIsNumber()]
                                  },
                                  model: {
                                    value: _vm.adjustment.amount,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.adjustment,
                                        "amount",
                                        _vm._n($$v)
                                      )
                                    },
                                    expression: "adjustment.amount"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { md3: "" } },
                              [
                                _c("v-select", {
                                  staticClass: "required_field",
                                  attrs: {
                                    label: _vm.$t("type"),
                                    items: _vm.adjustType,
                                    "item-text": "text",
                                    "item-value": "value",
                                    rules: [_vm.fieldIsRequired()]
                                  },
                                  model: {
                                    value: _vm.adjustment.type,
                                    callback: function($$v) {
                                      _vm.$set(_vm.adjustment, "type", $$v)
                                    },
                                    expression: "adjustment.type"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-flex",
                              { attrs: { md5: "" } },
                              [
                                _c("v-text-field", {
                                  attrs: { label: _vm.$t("keywords") },
                                  model: {
                                    value: _vm.adjustment.keywords,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.adjustment,
                                        "keywords",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression: "adjustment.keywords"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-flex")
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isTenant
              ? _c(
                  "v-layout",
                  {
                    attrs: { wrap: "", "justify-start": "", "align-center": "" }
                  },
                  [
                    _c(
                      "v-flex",
                      { attrs: { sm10: "" } },
                      [
                        _c("b", [
                          _vm._v(_vm._s(_vm.$t("uploadedFiles")) + ": ")
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-layout",
                          { attrs: { row: "", wrap: "" } },
                          _vm._l(_vm.adjustment.attachments || [], function(
                            file,
                            index
                          ) {
                            return _c("FsFileChip", {
                              key: "file" + index,
                              staticClass: "ma-2",
                              attrs: {
                                file: file,
                                width: "100%",
                                "aspect-ratio": "1.7"
                              }
                            })
                          }),
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { sm2: "" } },
                      [
                        _c("UploadFileWidget", {
                          ref: "fileUploader",
                          attrs: {
                            clearFiles: true,
                            type: "comments",
                            maxFiles: 9,
                            removeFiles: _vm.removeFiles,
                            icon: "",
                            isUseCameraUpload: ""
                          },
                          model: {
                            value: _vm.adjustment.attachments,
                            callback: function($$v) {
                              _vm.$set(_vm.adjustment, "attachments", $$v)
                            },
                            expression: "adjustment.attachments"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isTenant
              ? _c(
                  "v-flex",
                  [
                    _c(
                      "v-flex",
                      { attrs: { md6: "" } },
                      [
                        _c("v-autocomplete", {
                          staticClass: "required_field",
                          attrs: {
                            items: _vm.allUsers,
                            "item-text": "name",
                            "return-object": "",
                            label: _vm.$t("user"),
                            rules: [_vm.fieldIsRequired("user")],
                            clearable: ""
                          },
                          model: {
                            value: _vm.adjustment.userSelected,
                            callback: function($$v) {
                              _vm.$set(_vm.adjustment, "userSelected", $$v)
                            },
                            expression: "adjustment.userSelected"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { md3: "" } },
                      [
                        _c("v-text-field", {
                          staticClass: "required_field",
                          attrs: {
                            id: "balance_amount",
                            label: _vm.$t("amount"),
                            prefix: "$",
                            hint: _vm.$t("billingChangeHint"),
                            "persistent-hint": "",
                            rules: [_vm.fieldIsNumber()]
                          },
                          model: {
                            value: _vm.adjustment.amount,
                            callback: function($$v) {
                              _vm.$set(_vm.adjustment, "amount", _vm._n($$v))
                            },
                            expression: "adjustment.amount"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.adjustment.currencyType === "¥"
              ? _c(
                  "v-flex",
                  [
                    _c("v-icon", { attrs: { color: "warning" } }, [
                      _vm._v("warning")
                    ]),
                    _vm._v(" "),
                    _c("span", { staticStyle: { color: "#2196F3" } }, [
                      _vm._v(_vm._s(_vm.$t("noteRMBToUSD")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-layout",
              [
                _c("v-textarea", {
                  attrs: {
                    id: "balance_note",
                    label: _vm.$t("note"),
                    outline: ""
                  },
                  model: {
                    value: _vm.adjustment.note,
                    callback: function($$v) {
                      _vm.$set(_vm.adjustment, "note", $$v)
                    },
                    expression: "adjustment.note"
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64b1630f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b1630f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdjustBalancePopup.vue
// module id = null
// module chunks = 